import { memo } from "react";
import { YouTube, BookmarkBook, DashboardSpeed, Coin, ShopAlt, PinAlt } from "iconoir-react";
import { trackAyudaClick } from "../../../utils/gtm";

const links = [
  {
    href: "https://pagos.emcali.com.co/pagosweb/checkout",
    target: "_blank",
    icon: Coin,
    label: "Pagos"
  },
  {
    href: "/valoin",
    target: "_blank",
    icon: PinAlt,
    label: "Cobertura"
  },
  {
    href: "/planes",
    target: "_blank",
    icon: ShopAlt,
    label: "Cotizador"
  },
  // {
  //   href: "/guiauso",
  //   target: "_blank",
  //   icon: BookmarkBook,
  //   label: "Guía de uso"
  // },
  {
    href: "http://speedtest.emcali.net.co",
    target: "_blank",
    icon: DashboardSpeed,
    label: "Medidor de velocidad"
  },
  {
    href: "/grilla",
    target: "_blank",
    icon: YouTube,
    label: "Grilla de canales"
  }
];

export const Addhelp = () => {
  const commonStyles = "text-colorprimary bg-white flex flex-col justify-center items-center relative mt-1 border-none w-36 h-36 shadow-md rounded-2xl gap-4 hover:border-r-colorsecondary hover:border-solid hover:border-r-4 hover:text-colorsecondary";

  return (
    <div className="p-16 bg-white flex justify-center items-center flex-col" maxWidth="lg">
      <div className="flex flex-col justify-center items-center w-full">
        <h3 className="h2">
          <b>Ayuda</b>
        </h3>
        <hr className="underline" />
      </div>
      <section className="flex flex-wrap justify-center gap-3 max-w-2/4">
        {links.map(({ href, target, icon: Icon, label }) => (
          <a key={label} href={href} target={target} rel="noreferrer" className={commonStyles} onClick={() => trackAyudaClick(label)}>
            <Icon style={{ width: "2.5rem", height: "2.5rem" }} />
            <b>{label}</b>
          </a>
        ))}
      </section>
    </div>
  );
};

export default memo(Addhelp);
